---
title: "Oh My Pi Support Is Now Available in Entire"
description: "Capture Oh My Pi sessions as checkpoints so prompts, responses, recorded file changes, and tool activity stay connected to the repository history behind the work."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. Oh My Pi support is now available through an [external agent plugin](https://github.com/entireio/external-agents) for the [Entire CLI](https://github.com/entireio/cli), thanks to community contributor @[Kh05ifr4nD](https://github.com/Kh05ifr4nD).

[Oh My Pi](https://omp.sh/) is an independently maintained, open source fork of [Pi](https://github.com/earendil-works/pi) that adds language-server intelligence, debugging, browser access, and subagents to its terminal-first workflow.

Once enabled in a repository, Entire automatically captures Oh My Pi sessions as checkpoints and keeps their context attached to the repository history. Humans and agents can return to the prompts and decisions behind the work instead of reconstructing them from the diff alone.

<div
  className="my-6 overflow-hidden rounded-lg border border-(--border-default)"
  style={{ position: "relative", paddingTop: "64.5933014354067%" }}
>
  <iframe
    src="https://customer-0x5hsk8lh27fm00g.cloudflarestream.com/a71b3239a7bf504739dc6b8c0243bca9/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-0x5hsk8lh27fm00g.cloudflarestream.com%2Fa71b3239a7bf504739dc6b8c0243bca9%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
    title="Oh My Pi session capture"
    loading="lazy"
    className="absolute top-0 left-0 h-full w-full border-0"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>

After setup, use Oh My Pi as usual. Entire follows the active conversation and creates checkpoints as the work progresses, even when you switch sessions or branch from an earlier turn. Each checkpoint is available from the [CLI](https://github.com/entireio/cli) and [Entire web app](https://entire.io/) with its prompts, responses, recorded file changes, tool activity, and token usage when available.

## Try It

Install [Oh My Pi](https://omp.sh/) and the `entire-agent-omp` plugin. You can build the plugin from the external-agents repository:

```shell
git clone https://github.com/entireio/external-agents.git
cd external-agents/agents/entire-agent-omp
go build -o entire-agent-omp ./cmd/entire-agent-omp
mkdir -p ~/.local/bin
cp entire-agent-omp ~/.local/bin/
```

Make sure `~/.local/bin` is on your `PATH`, then allow external-agent discovery in `.entire/settings.json`:

```json
{
  "external_agents": true
}
```

From the root of the repository you want Entire to track, enable Oh My Pi and start it as usual:

```shell
entire enable --agent omp
omp
```

## Learn More

Read the [external agent plugin documentation](https://docs.entire.io/agents/external-agent-plugins) or visit the [`entire-agent-omp` README](https://github.com/entireio/external-agents/tree/main/agents/entire-agent-omp) for setup details and current limitations.

Boop.
